import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-primary-violet font-bold capitalize" }
const _hoisted_2 = { class: "text-xl font-bold" }

import { useRouter } from "vue-router"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ResourcesImage',
  props: {
    data: null
  },
  setup(__props: any) {

const props = __props as {
    data: {
      title: string
      topic: string
      image: string
      format: string
      url: string
    }
  }

  

  const router = useRouter()

  const goToPage = () => {
    window.location.href = `/resources/${props.data.format.toLowerCase()}${props.data.url}`
  }

return (_ctx: any,_cache: any) => {
  const _component_ion_label = _resolveComponent("ion-label")!

  return (_openBlock(), _createBlock(_component_ion_label, {
    class: "flex flex-col gap-2 max-w-[23rem] mx-auto",
    onClick: goToPage
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "rounded-base h-[330px] w-full flex flex-col items-center justify-center bg-center bg-cover",
        style: _normalizeStyle({ backgroundImage: `url(${props.data.image})` })
      }, null, 4),
      _createElementVNode("span", _hoisted_1, _toDisplayString(props.data.topic), 1),
      _createElementVNode("p", _hoisted_2, _toDisplayString(props.data.title), 1)
    ]),
    _: 1
  }))
}
}

})